import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './Cycler.css';

class Cycler extends PureComponent {
  state = {
    itemIndex: 0
  };

  timeout = null;

  componentDidMount() {
    this.scheduleNext();
  }

  scheduleNext = () => {
    const { durationMs, transitionMs, items } = this.props;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (items.length > 1) {
      this.timeout = setTimeout(this.switchText, durationMs + transitionMs);
    }
  };

  switchText = () => {
    const { items } = this.props;
    if (items.length > 1) {
      this.setState({
        itemIndex: (this.state.itemIndex + 1) % items.length
      });
      this.scheduleNext();
    }
  };

  componentWillUnmount() {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
  }

  render() {
    const { className, items, transitionMs } = this.props;
    const { itemIndex } = this.state;
    const transition = `opacity ${transitionMs}ms linear`;

    return (
      <div className={`cycler ${className || ''}`}>
        {items.map((item, idx) => {
          const opacity = idx <= itemIndex ? 1 : 0;
          return (
            <div key={idx} style={{ transition, opacity }}>
              {item}
            </div>
          );
        })}
      </div>
    );
  }
}

Cycler.propTypes = {
  className: PropTypes.string,
  durationMs: PropTypes.number,
  transitionMs: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.any).isRequired
};

Cycler.defaultProps = {
  durationMs: 4000,
  transitionMs: 300
};

export default Cycler;
